export { default } from "./StudentAssignmentFootnote";
